module.exports = __webpack_public_path__ + "static/img/wlhxt2b.67cc3fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wlhxt2b.png
// module id = 78C6
// module chunks = 73